/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ReportApiService {

    protected basePath = 'https://app-tst.pikyrent.com:33443';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create report
     * 
     * @param deviceName 
     * @param description 
     * @param warningTypeId 
     * @param fileObject 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newWarningForm(deviceName?: string, description?: string, warningTypeId?: number, fileObject?: Blob, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public newWarningForm(deviceName?: string, description?: string, warningTypeId?: number, fileObject?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public newWarningForm(deviceName?: string, description?: string, warningTypeId?: number, fileObject?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public newWarningForm(deviceName?: string, description?: string, warningTypeId?: number, fileObject?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (deviceName !== undefined) {
            formParams = formParams.append('deviceName', <any>deviceName) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('description', <any>description) as any || formParams;
        }
        if (warningTypeId !== undefined) {
            formParams = formParams.append('warningTypeId', <any>warningTypeId) as any || formParams;
        }
        if (fileObject !== undefined) {
            formParams = formParams.append('fileObject', <any>fileObject) as any || formParams;
        }

        return this.httpClient.request<any>('post',`${this.basePath}/warning/`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
